import { render } from "./AssignmentTabs.vue?vue&type=template&id=5f12764d&ts=true"
import script from "./AssignmentTabs.vue?vue&type=script&lang=ts"
export * from "./AssignmentTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__